export const AD_ZONE_BANNER = 'ad-zone-banner';
export const AD_ZONE_FOOTER_POPUP = 'ad-zone-footer-popup';
export const AD_ZONE_GALLERY_INLINE_BANNER = 'ad-zone-gallery-inline-banner';
export const AD_ZONE_GATEWAY_DESKTOP = 'ad-zone-gateway-desktop';
export const AD_ZONE_HEADER_RIBBON = 'ad-zone-header-ribbon';
export const AD_ZONE_POPUP = 'ad-zone-popup';
export const AFFILIATE_PURCHASE = 'affiliate-purchase';
export const BLOG_COMMENT = 'blog-comment';
export const BLOG_REDIRECT = 'blog-redirect';
export const COMMENT = 'comment';
export const EMAIL_LOGIN = 'email-login';
export const FAVORITE_BUTTON = 'favorite-button';
export const FAVORITE_MODEL_CARD = 'favorite-model-card';
export const FAVORITE_MOVIE = 'favorite-movie';
export const FAVORITE_PHOTOGRAPHER_CARD = 'favorite-photographer-card';
export const FOOTER = 'footer';
export const FOOTER_DISCOUNTS = 'footer_discounts';
export const FOOTER_MOBILE_NAV = 'footer-mobile-nav';
export const FREE_TRIAL_FLOATER = 'free-trial-floater';
export const GALLERY_COVER = 'gallery-cover';
export const GALLERY_FAVORITE = 'gallery-favorite';
export const GALLERY_IMAGE_ACTION = 'gallery-image-action';
export const GALLERY_IMAGE_ERROR = 'gallery-image-error';
export const GALLERY_PAGE = 'gallery-page';
export const GALLERY_PURCHASE_PANEL = 'gallery-purchase-panel';
export const GALLERY_RATING = 'gallery-rating';
export const GALLERY_THUMBNAIL = 'gallery-thumbnail';
export const GALLERY_UPGRADE = 'gallery-upgrade';
export const GATEWAY_REPLACEMENT_FLOATER = 'gateway-replacement-floater';
export const GUEST_GATEWAY_MODAL = 'guest-gateway-modal';
export const GUEST_VERIFY_MODAL = 'guest-verify-modal';
export const GUEST_VERIFY_RIBBON = 'guest-verify-ribbon';
export const HEADER_BAR = 'header-bar';
export const HEADER_DISCOUNTS = 'header_discounts';
export const LAST_CHANCE_SECTION = 'last-chance-section';
export const LOGIN_REDIRECT = 'login-redirect';
export const MANAGE_ACCOUNT = 'manage-account';
export const MOBILE_MENU = 'mobile-menu';
export const MODEL_COMMENT = 'model-comment';
export const MOVIE_COVER = 'movie-cover';
export const MOVIE_GALLERY = 'movie-gallery';
export const NETWORK_SLIDER = 'network-slider';
export const NON_NUDE_VIDEO = 'non-nude-video';
export const OUTRO = 'outro';
export const PAGE_404 = '404-page';
export const PLAYBOY_SPLASH_BANNER = 'playboy-splash-banner';
export const PLAYBOY_UPDATES_BANNER = 'playboy-updates-banner';
export const PPS_PURCHASE = 'pps-purchase';
export const PROMOTION_BANNER = 'promotion-banner';
export const RATE_ACTIVITY_PANEL = 'rate-activity-panel';
export const RATE_MODEL_CARD = 'rate-model-card';
export const RATE_MOVIE = 'rate-movie';
export const RATE_PHOTOGRAPHER_CARD = 'rate-photographer-card';
export const REDGIFS_PROMO = 'redgifs-promo';
export const SITE_PICKER = 'site-picker';
export const SPECIAL_FEATURES = 'special-features';
export const SPLASH_ABOUT_BOTTOM = 'splash-about-bottom';
export const SPLASH_ABOUT_TOP = 'splash-about-top';
export const SPLASH_OUTRO = 'splash-outro';
export const STATIC_SPLASH_INFO_PANEL_1 = 'static-splash-info-panel-1';
export const STATIC_SPLASH_INFO_PANEL_2 = 'static-splash-info-panel-2';
export const STATIC_SPLASH_INTRO = 'static-splash-intro';
export const STATIC_SPLASH_THUMBNAIL_CLASSICS = 'static-splash-classics';
export const STATIC_SPLASH_THUMBNAIL_GALLERIES = 'static-splash-galleries';
export const STATIC_SPLASH_THUMBNAIL_MODELS = 'static-splash-models';
export const STATIC_SPLASH_THUMBNAIL_MOVIES = 'static-splash-movies';
export const UNAUTHORIZED_ROUTE = 'unauthorized-route';
export const UPGRADE_DIALOG = 'upgrade-dialog';
export const UPGRADE_FREE_MONTH = 'upgrade-free-month';
export const UPGRADE_STRIP_MODAL = 'upgrade-strip-modal';
export const UPGRADE_STRIP = 'upgrade-strip';
export const UPGRADES_REDIRECT = 'upgrades-redirect';
